import Landing from "../Components/Landing"
import "../style/user.css"

const Home = () => {
return (
    <Landing/>
)
}

 export default Home